import React, { useState, useEffect } from 'react'
import { Container, Col, Row, Table } from 'reactstrap'
import Modal from 'react-modal'
import Select from 'react-select'
import { ModalInfo } from '../modules'
import { Loader, Paginate, Search } from 'admin-console-common'
import {
  getListUsers,
  getUsersFilteredAndSorted,
  getAttrUser,
  updateStatusUser,
  updateRoleUser,
  checkAccess,
  getDealers,
  getDealerNameById,
  filteredUsersByAdmin,
  getLabelMarket,
  getMarketsByCountry,
} from '../Helpers'
import dashboardsJson from '../dashboards'
import entitiesJson from '../entities'
import LoaderImg from '../assets/img/loader.gif'
import { useUserContext } from '../hooks/useUser'

const Members = props => {
  const [users, setUsers] = useState([])
  const [infosModal, setInfosModal] = useState('')
  const [search, setSearch] = useState('')
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [modalRoleIsOpen, setModalRoleIsOpen] = useState(false)
  const [currentUser, setCurrentUser] = useState({})
  const [roles, setRoles] = useState([])
  const [role, setRole] = useState([])
  const [dealers, setDealers] = useState([])
  const [allDealers, setAllDealers] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [loader, setLoader] = useState(true)
  const [market, setMarket] = useState({ label: 'Select a Market', value: '' })
  const [dealer, setDealer] = useState([])
  const [dashboard, setDashboard] = useState([])
  const [filterRole, setFilterRole] = useState()
  const [dashboards] = useState(dashboardsJson)
  const { user } = useUserContext()

  const markets = getMarketsByCountry()
  const membersPerPage = 8

  useEffect(() => {
    const fetchData = async () => {
      checkAccess(user, 'membersMenu', props.history)
      const resultsUsers = await getUsers(user)
      const dealerFr = await getDealers('fr-FR')
      const dealerPl = await getDealers('pl-PL')
      const allDealers = [...dealerFr.dealers, ...dealerPl.dealers]
      const _entitiesJson = [{ label: 'ALL ROLES', value: '' }, ...entitiesJson]

      setAllDealers(allDealers)
      setRoles(
        user?.attributes['custom:entity'] !== 'ADMIN'
          ? _entitiesJson.filter(entity => entity.label !== 'ADMIN')
          : _entitiesJson
      )
      setUsers(resultsUsers)
      setLoader(false)
    }
    fetchData()
  }, [props.history, user])

  const getUsers = async authenticatedUser => {
    let resultsUsers = await getListUsers()

    resultsUsers = resultsUsers.filter(
      user => user.UserStatus !== 'EXTERNAL_PROVIDER'
    )

    if (
      authenticatedUser?.attributes['custom:entity'] === 'ADMIN_RBU' ||
      authenticatedUser?.attributes['custom:entity'] === 'ADMIN_DEALER'
    ) {
      resultsUsers = filteredUsersByAdmin(resultsUsers, authenticatedUser)
    }

    return resultsUsers
  }

  const handleClickStatus = async (_user, status) => {
    await updateStatusUser(_user, status)
    let resultsUsers = await getUsers(user)
    setInfosModal(_user.Username + ' have been updated')
    setModalIsOpen(true)
    setUsers(resultsUsers)
  }

  const handleChangeModalMarket = async market => {
    setMarket(market)
    if (role.value === 'DEALER') {
      const response = await getDealers(market.value)
      setDealers(response.dealers)
      setDealer([])
    }
  }

  const handleClickRole = async currentUser => {
    const role = {
      label: getAttrUser('custom:entity', currentUser),
      value: getAttrUser('custom:entity', currentUser),
    }
    const market =
      getAttrUser('custom:market', currentUser) === ''
        ? { label: 'Select a Market', value: '' }
        : {
            label: getLabelMarket(getAttrUser('custom:market', currentUser)),
            value: getAttrUser('custom:market', currentUser),
          }

    let dealer = []
    if (getAttrUser('custom:entityId', currentUser))
      dealer = getDealerNameById(
        getAttrUser('custom:entityId', currentUser),
        allDealers
      )

    if (role.value === 'DEALER' && market.value !== '') {
      const results = await getDealers(market.value)
      setDealers(results.dealers)
    }

    const dashboardString = getAttrUser('custom:dashboard', currentUser)
    let dashboardsSelected = []
    if (dashboardString !== '') {
      const dashboardOpts = dashboardString.split(' / ')
      for (let opt of dashboardOpts) {
        const dashboardObject = dashboards.filter(item => item.value === opt)
        dashboardsSelected.push(dashboardObject[0])
      }
    }

    setCurrentUser(currentUser)
    setRole(role)
    setMarket(market)
    setDealer(dealer)
    setDashboard(dashboardsSelected)
    setModalRoleIsOpen(true)
  }

  const getDealerById = dealer => {
    let dealerStr = ''
    for (let item of allDealers) {
      if (dealer.includes(item.value)) dealerStr += `${item.label}, `
    }

    dealerStr = dealerStr.substring(0, dealerStr.length - 2)

    return dealerStr
  }

  const handleRole = role => {
    setRole(role)
    setMarket({ label: 'Select a Market', value: '' })
    setDealer({ label: 'Select a Dealer', value: '' })
    setDashboard([])
  }

  const handleClickSave = async () => {
    let data = {}

    if (getAttrUser('custom:entity', currentUser) !== role.value)
      data.role = { name: 'custom:entity', value: role.value }
    if (getAttrUser('custom:market', currentUser) !== market.value)
      data.market = { name: 'custom:market', value: market.value }

    let dealerString = ''
    if (dealer.length > 0) {
      for (let key in dealer) {
        if (parseInt(key) === parseInt(dealer.length - 1))
          dealerString += dealer[key].value
        else dealerString += dealer[key].value + ';'
      }

      if (getAttrUser('custom:entityId', currentUser) !== dealer)
        data.dealer = { name: 'custom:entityId', value: dealerString }
    }

    let dashboardString = ''
    if (dashboard.length > 0) {
      for (let key in dashboard) {
        if (parseInt(key) === parseInt(dashboard.length - 1))
          dashboardString += dashboard[key].value
        else dashboardString += dashboard[key].value + ' / '
      }

      if (getAttrUser('custom:dashboard', currentUser) !== dashboard)
        data.dashboard = { name: 'custom:dashboard', value: dashboardString }
    } else {
      data.dashboard = {
        name: 'custom:dashboard',
        value: getAttrUser('custom:dashboard', currentUser),
      }
    }

    if (role.value !== 'DEALER') {
      data.dealer = { name: 'custom:entityId', value: '' }
    }

    if (!role.value.includes('RBU') && !role.value.includes('DEALER')) {
      data.market = { name: 'custom:market', value: '' }
    }

    await updateRoleUser(currentUser.Username, data)
    const usersUpdated = await getListUsers()

    setInfosModal(currentUser.Username + ' have been updated.')
    setModalRoleIsOpen(false)
    setModalIsOpen(true)
    setUsers(usersUpdated)
  }

  let usersList = [...users]
  usersList = getUsersFilteredAndSorted(usersList, filterRole, search)

  const indexOfLastMembers = currentPage * membersPerPage
  const indexOfFirstMembers = indexOfLastMembers - membersPerPage
  const membersPaginate = usersList

  usersList = usersList.slice(indexOfFirstMembers, indexOfLastMembers)

  return (
    <Container fluid>
      {loader ? (
        <Loader loaderImg={LoaderImg} />
      ) : (
        <div className="members panel panel--light mt-5">
          <Row className="filters">
            <Col xs="6" lg="6">
              <h2>MEMBERS</h2>
            </Col>
            <Col xs="12" lg="3" className="mb-3 mb-lg-0">
              <Select
                value={filterRole}
                defaultValue={filterRole}
                onChange={filterRole => {
                  setFilterRole(filterRole)
                  setCurrentPage(1)
                }}
                options={roles}
                isSearchable={true}
                className="select-custom"
                classNamePrefix="select-custom"
                placeholder="Select a ROLE"
              />
            </Col>
            <Col xs="12" lg="3">
              <Search
                value={search}
                withFa={true}
                placeholder="Search by Username or Email"
                change={e => setSearch(e.target.value)}
                click={() => setSearch('')}
              />
            </Col>
          </Row>

          <Table responsive className="mb-4">
            <thead>
              <tr>
                <th>Username</th>
                <th>Entity</th>
                <th>
                  Dealer{' '}
                  <i
                    title="Hover the dealer IDs below to show the dealer names"
                    className="fa fa-info-circle"
                  ></i>
                </th>
                <th>Market</th>
                <th>Access to</th>
                <th>Email</th>
                <th>Last connexion</th>
                <th>
                  <span style={{ visibility: 'hidden' }}>Actions</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {usersList.length > 0 ? (
                usersList.map((user, index) => {
                  let email,
                    entity,
                    market,
                    dealer,
                    dashboardStr,
                    isValidated,
                    lastConnexion
                  for (let attribute in user.Attributes) {
                    if (user.Attributes[attribute].Name === 'email') {
                      email = user.Attributes[attribute].Value
                    }
                    if (user.Attributes[attribute].Name === 'custom:entity') {
                      entity = user.Attributes[attribute].Value
                    }
                    if (user.Attributes[attribute].Name === 'custom:market') {
                      market = user.Attributes[attribute].Value
                    }
                    if (user.Attributes[attribute].Name === 'custom:entityId') {
                      dealer =
                        user.Attributes[attribute].Value.split(';').join(' ; ')
                    }
                    if (
                      user.Attributes[attribute].Name === 'custom:dashboard'
                    ) {
                      dashboardStr = user.Attributes[attribute].Value
                    }
                    if (
                      user.Attributes[attribute].Name === 'custom:isValidated'
                    ) {
                      isValidated = user.Attributes[attribute].Value
                    }
                    if (
                      user.Attributes[attribute].Name === 'custom:lastConnexion'
                    ) {
                      lastConnexion = new Date(user.Attributes[attribute].Value)
                    }
                  }
                  return (
                    <tr key={index}>
                      <td>
                        {user.Enabled &&
                        user.UserStatus === 'CONFIRMED' &&
                        isValidated === '1' ? (
                          <i className="fa fa-user confirmed"></i>
                        ) : (
                          <i className="fa fa-user-times unconfirmed"></i>
                        )}
                        {user.Username}
                      </td>
                      <td>{entity}</td>
                      <td
                        className="table-dealer"
                        title={dealer ? getDealerById(dealer) : '-'}
                      >
                        {dealer ? dealer : ' - '}
                      </td>
                      <td>{market ? getLabelMarket(market) : ' - '}</td>
                      <td>{dashboardStr ? dashboardStr : ' - '}</td>
                      <td>{email}</td>
                      <td>
                        {lastConnexion
                          ? `${lastConnexion.toLocaleDateString()} ${lastConnexion.toLocaleTimeString()}`
                          : '-'}
                      </td>
                      <td>
                        <i
                          className="fa fa-edit edit"
                          onClick={() => handleClickRole(user)}
                          title="Edit role"
                        ></i>
                        {isValidated && isValidated === '1' && (
                          <i
                            className="fa fa-times-circle disabled"
                            onClick={() => handleClickStatus(user, 'disabled')}
                            title="Disabled User"
                          ></i>
                        )}
                        {(!isValidated || isValidated === '0') && (
                          <i
                            className="fa fa-check-circle confirm"
                            onClick={() => handleClickStatus(user, 'confirmed')}
                            title="Confirm User"
                          ></i>
                        )}
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td>No results found.</td>
                </tr>
              )}
            </tbody>
          </Table>

          {usersList.length > 0 && (
            <Paginate
              datas={membersPaginate}
              handleClickPage={e =>
                setCurrentPage(
                  parseInt(e.currentTarget.getAttribute('data-page'))
                )
              }
              currentPage={currentPage}
              datasPerPage={membersPerPage}
            />
          )}

          <ModalInfo
            isOpen={modalIsOpen}
            close={() => setModalIsOpen(false)}
            info={infosModal}
            title="Success"
          />
          <Modal
            isOpen={modalRoleIsOpen}
            onRequestClose={() => setModalRoleIsOpen(false)}
            contentLabel="Modal"
            ariaHideApp={false}
          >
            <p
              className="close-modal"
              onClick={() => setModalRoleIsOpen(false)}
            >
              Close<i className="fa fa-times"></i>
            </p>
            <div className="modal-board modal-board-role">
              <div>
                Select an entity :
                <Select
                  value={role}
                  defaultValue={role}
                  onChange={role => handleRole(role)}
                  options={roles}
                  isSearchable={true}
                  className="select-custom"
                  classNamePrefix="select-custom"
                />
              </div>
              {role.value &&
                (role.value.includes('DEALER') ||
                  role.value.includes('RBU')) && (
                  <>
                    <div style={{ marginTop: '20px' }}>
                      Select a market :
                      <Select
                        value={market}
                        defaultValue={market}
                        onChange={handleChangeModalMarket}
                        options={markets}
                        isSearchable={true}
                        className="select-custom"
                        classNamePrefix="select-custom"
                      />
                    </div>
                  </>
                )}
              {role.value === 'DEALER' && (
                <>
                  <div style={{ marginTop: '20px' }}>
                    Select a dealer :
                    <Select
                      value={dealer}
                      onChange={dealer => setDealer(dealer)}
                      options={dealers}
                      isSearchable={true}
                      className="select-custom"
                      classNamePrefix="select-custom"
                      isMulti={true}
                      placeholder={'Select a dealer'}
                    />
                  </div>
                </>
              )}
              {(role.value === 'RBU' || role.value === 'CEC') && (
                <>
                  <div style={{ marginTop: '20px' }}>
                    Select a dashboard :
                    <Select
                      value={dashboard}
                      defaultValue={dashboard}
                      onChange={dashboard => setDashboard(dashboard)}
                      options={dashboards}
                      isSearchable={true}
                      className="select-custom"
                      classNamePrefix="select-custom"
                      isMulti={true}
                    />
                  </div>
                </>
              )}
              <br />
              <div>
                <button
                  className="btn-nissan-grey"
                  onClick={() => setModalRoleIsOpen(false)}
                >
                  Cancel<i className="fa fa-chevron-right"></i>
                </button>
                <button
                  className="btn-nissan-red"
                  style={{ marginLeft: '20px' }}
                  onClick={handleClickSave}
                >
                  Save<i className="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </Container>
  )
}

export default Members
